import { render } from "./ProposalActionBar.vue?vue&type=template&id=2c13a4a5"
import script from "./ProposalActionBar.vue?vue&type=script&lang=js"
export * from "./ProposalActionBar.vue?vue&type=script&lang=js"

import "./ProposalActionBar.vue?vue&type=style&index=0&id=2c13a4a5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__